// extracted by mini-css-extract-plugin
module.exports = {"booked":"booked__2hsmk","bookedBody":"booked__body__1j94m","bookedIcon":"booked__icon__1v_31","bookedTitle":"booked__title__2-ttE","bookedConfetti":"booked__confetti__2NbED"};